import { API_ERROR } from "../../auth/login/actionTypes";
import {
  ADD_CARD, ADD_CARD_FAILED, ADD_CARD_SUCCESSFUL, GET_CARD_LIST, GET_CARD_LIST_SUCCESSFUL, GET_CARD_LIST_FAILED, REMOVE_CARD, REMOVE_CARD_SUCCESSFUL, DEFAULT_CARD, DEFAULT_CARD_SUCCESSFUL,
  GET_INVOICES, GET_INVOICES_SUCCESSFUL, ADD_CARD_RESET, GET_PLAN, GET_PLAN_SUCCESSFUL, GET_PLAN_FAILED, GET_INVOICES_FAILED, REMOVE_CARD_FAILED, DEFAULT_CARD_FAILED, ADD_BILL_ADDRESS, ADD_BILL_ADDRESS_SUCCESSFUL, ADD_BILL_ADDRESS_FAILED, GET_BILL_ADDRESS_DETAILS, GET_BILL_ADDRESS_DETAILS_SUCCESSFUL, GET_BILL_ADDRESS_DETAILS_FAILED, EDIT_BILL_ADDRESS, EDIT_BILL_ADDRESS_SUCCESSFUL, EDIT_BILL_ADDRESS_FAILED, RESET_CARD_ALERT,
  GET_TIMEZONES_LIST,
  SET_TIMEZONES_LIST,
  UPDATE_TIMEZONE,
  SET_SETUP_POPUP,
  SET_PAYEMENT_INFO,
} from "./actionTypes"
const initialState = {
  repMessage: null,
  cardAddLoading: false,
  cardAddedEr: false,
  cardList: null,
  addCardErr: null,
  defCardErr: null,
  remCardErr: null,
  addBillAddErr: null,
  editBillAddErr: null,
  cardListLoading: true,
  invList: null,
  invListLoading: false,
  planDetLoading: false,
  planDetails: null,
  apiError: false,
  cardAdded: false,
  cardRemoveLoading: false,
  defaultCardLoading: false,
  billAddress: null,
  billAddressLoading: false,
  getBillAddressLoading: true,
  editBillAddressLoading: false,
  addBillAddErr: null,
  responseAddressStatus: null,
  cardResponse: null,
  billAdressFetched: false,
  timeZonesDetails: {
    loading: false,
    listofTimeZones: null,
    responseMessage: null,
    responseStatus: null,
    selectedTimeZone: null,
    updateTimeZoneLoading: false,
  },
  setupPopup: true,
  setPayementInfo: {
    submitCardDetails: false,
    cancelCardDetails: false,
    billingErrors: false,

  },
  cardAddLoadingForPaymentInfo: false,

}

const Bill = (state = initialState, action) => {
  const { responseCode, responseMessage, response, responseStatus, showMessage } = action.payload || {};
  switch (action.type) {
    case ADD_CARD:
      state = {
        ...state,
        cardAddLoading: true,
        cardAdded: false
      }
      break
    case ADD_CARD_SUCCESSFUL:
      state.cardList.list.unshift(response);
      state.cardList.count++;
      console.log('state.cardList.count', state.cardList.count)
      state = {
        ...state,
        cardAddLoading: false,
        cardResponse: response,
        cardAdded: true,
        addCardErr: false,
        repMessage: responseMessage,
        billAddressLoading: state.cardList.count === 1 ? true : false,
        cardAddLoadingForPaymentInfo: state.cardList.count === 1 ? true : false

      }

      break
    case ADD_CARD_RESET:
      state = {
        ...state,
        cardResponse: null,
      }
      break
    case ADD_CARD_FAILED:
      state = {
        ...state,
        cardAddLoading: false,
        cardAdded: false,
        addCardErr: true,
        repMessage: responseMessage
      }
      break
    case RESET_CARD_ALERT:
      state = {
        ...state,
        repMessage: null,
        addCardErr: null,
        defCardErr: null,
        remCardErr: null,
        editBillAddErr: null,
        addBillAddErr: null,
        timeZonesDetails: {
          ...state.timeZonesDetails,
          responseMessage: null
        }
      }
      break
    case GET_CARD_LIST:
      state = {
        ...state,
        cardListLoading: true,
      }
      break
    case GET_CARD_LIST_SUCCESSFUL:
      state = {
        ...state,
        cardListLoading: false,
        cardList: response,
      }
      break
    case GET_CARD_LIST_FAILED:
      state = {
        ...state,
        cardListLoading: false,
        cardList: null,
      }
      break
    case REMOVE_CARD:
      state = {
        ...state,
        cardRemoveLoading: true
      }
      break
    case REMOVE_CARD_SUCCESSFUL:
      let remItemList = state.cardList.list.filter((cd) => cd.id !== response.payment_method_id);
      state.cardList.list = remItemList
      state.cardList.count--;
      state = {
        ...state,
        repMessage: responseMessage,
        cardRemoveLoading: false,
        remCardErr: false,
      }
      break
    case REMOVE_CARD_FAILED:
      state = {
        ...state,
        repMessage: responseMessage,
        cardRemoveLoading: false,
        remCardErr: true,
      }
      break
    case DEFAULT_CARD:
      state = {
        ...state,
        defaultCardLoading: true
      }
      break
    case DEFAULT_CARD_SUCCESSFUL:
      let defCardIndex = state.cardList.list.findIndex((cd) => cd.id === response.payment_method_id)
      let prevDefCardIndex = state.cardList.list.findIndex((cd) => cd.default === true)
      state.cardList.list[defCardIndex].default = true
      state.cardList.list[prevDefCardIndex].default = false
      state = {
        ...state,
        defaultCardLoading: false,
        defCardErr: false,
        repMessage: responseMessage,
      }
      break
    case DEFAULT_CARD_FAILED:
      state = {
        ...state,
        defaultCardLoading: false,
        defCardErr: true,
        repMessage: responseMessage,
      }
      break
    case GET_INVOICES:
      state = {
        ...state,
        invListLoading: true,
      }
      break

    case GET_INVOICES_SUCCESSFUL:
      state = {
        ...state,
        invList: response,
        invListLoading: false,
      }
      break
    case GET_INVOICES_FAILED:
      state = {
        ...state,
        invList: null,
        invListLoading: false,
      }
      break

    case GET_PLAN:
      state = {
        ...state,
        planDetLoading: true,
      }
      break
    case GET_PLAN_SUCCESSFUL:
      state = {
        ...state,
        planDetLoading: false,
        planDetails: response,
      }
      break
    case GET_PLAN_FAILED:
      state = {
        ...state,
        planDetLoading: false,
        planDetails: null,
      }
      break
    case ADD_BILL_ADDRESS:
      state = {
        ...state,
        billAddressLoading: true,
      }
      break
    case ADD_BILL_ADDRESS_SUCCESSFUL:
      console.log(response)
      state = {
        ...state,
        billAddress: response,
        billAddressLoading: false,
        addBillAddErr: false,
        repMessage: responseMessage,
        cardAddLoadingForPaymentInfo: false

      }
      break
    case ADD_BILL_ADDRESS_FAILED:
      state = {
        ...state,
        billAddressLoading: false,
        addBillAddErr: true,
        repMessage: responseMessage
      }
      break
    case EDIT_BILL_ADDRESS:
      state = {
        ...state,
        editBillAddressLoading: true,
      }
      break
    case EDIT_BILL_ADDRESS_SUCCESSFUL:
      state = {
        ...state,
        billAddress: response,
        editBillAddressLoading: false,
        editBillAddErr: false,
        repMessage: responseMessage
      }
      break
    case EDIT_BILL_ADDRESS_FAILED:
      state = {
        ...state,
        editBillAddressLoading: false,
        editBillAddErr: true,
        repMessage: responseMessage,
      }
      break

    case GET_BILL_ADDRESS_DETAILS:
      state = {
        ...state,
        billAddress: null,
        getBillAddressLoading: true,
        responseAddressStatus: null
      }
      break

    case GET_BILL_ADDRESS_DETAILS_SUCCESSFUL:
      state = {
        ...state,
        billAddress: Object.keys(response).length > 0 ? response : null,
        getBillAddressLoading: false,
        responseAddressStatus: responseStatus,
        billAdressFetched: true
      }
      break

    case GET_BILL_ADDRESS_DETAILS_FAILED:
      state = {
        ...state,
        billAddress: null,
        getBillAddressLoading: false,
        responseAddressStatus: responseStatus
      }
      break
    case API_ERROR:
      state = {
        ...state,
        apiError: true,
        invListLoading: false,
        planDetLoading: false,
        cardListLoading: false,
        cardRemoveLoading: false,
        cardAddLoading: false,
        defaultCardLoading: false,
        billAddressLoading: false,
        getBillAddressLoading: false,
        editBillAddressLoading: false,
      }
      break
    case GET_TIMEZONES_LIST:
      state = {
        ...state,
        timeZonesDetails: {
          ...state.timeZonesDetails,
          loading: true
        }
      }
      break
    case SET_TIMEZONES_LIST:
      state = {
        ...state,
        timeZonesDetails: {
          ...state.timeZonesDetails,
          loading: false,
          listofTimeZones: action.payload.response || state.timeZonesDetails?.listofTimeZones,
          responseMessage: action.payload.responseMessage,
          responseStatus: action.payload.responseStatus,
          selectedTimeZone: action.payload.selectedTimeZone || state.timeZonesDetails?.selectedTimeZone,
          updateTimeZoneLoading: action.payload.updateTimeZoneLoading || false

        }
      }
      break
    case UPDATE_TIMEZONE:
      state = {
        ...state,
        timeZonesDetails: {
          ...state.timeZonesDetails,
          updateTimeZoneLoading: true,
        }
      }
      break
    case SET_SETUP_POPUP:
      state = {
        ...state,
        setupPopup: false
      }
      break
    case SET_PAYEMENT_INFO:
      state = {
        ...state,
        setPayementInfo: {
          ...state.setPayementInfo,
          ...action.payload
        },
        cardAddLoadingForPaymentInfo: action.payload?.cardAddLoadingForPaymentInfo === false ? action.payload?.cardAddLoadingForPaymentInfo : state.cardAddLoadingForPaymentInfo,
        billAddressLoading: action.payload?.billAddressLoading === false ? action.payload?.billAddressLoading : state.billAddressLoading,

      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default Bill
